var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.88889 2.44444C2.88889 1.83079 3.38635 1.33333 4 1.33333C4.61365 1.33333 5.11111 1.83079 5.11111 2.44444V3.77734H2.88889V2.44444ZM1.55556 3.77734V2.44444C1.55556 1.09441 2.64997 0 4 0C5.35003 0 6.44444 1.09442 6.44444 2.44444V3.77734H7.11111C7.60203 3.77734 8 4.17531 8 4.66623V9.11068C8 9.6016 7.60203 9.99957 7.11111 9.99957H0.888889C0.397969 9.99957 0 9.6016 0 9.11068V4.66623C0 4.17531 0.397969 3.77734 0.888889 3.77734H1.55556ZM5.33366 6.88802C5.33366 7.6244 4.73671 8.22135 4.00033 8.22135C3.26395 8.22135 2.66699 7.6244 2.66699 6.88802C2.66699 6.15164 3.26395 5.55469 4.00033 5.55469C4.73671 5.55469 5.33366 6.15164 5.33366 6.88802Z",
    fill: "#5C6682"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockImg);
export default __webpack_public_path__ + "static/media/lock-img.826454b8222f918be0b467b4c685b8cf.svg";
export { ForwardRef as ReactComponent };